/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'open': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M25 28H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h6v2H7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-6h2v6c0 1.7-1.3 3-3 3z"/><path pid="1" d="M19 4v2h5.6L13.8 16.8l1.4 1.4L26 7.4V13h2V4z"/>'
  }
})
